
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  PurchaseOrderProductInfos,
  PurchaseOrderProductInfosMore,
  FactoryInfos,
  FinancialConfiguration,
} from "@/model/FinancialBookingModels";
import { divide } from "@/utils/number";
import { isEmpty, toUpper } from "lodash";
import { LoadingPlanType } from "@/views/sales-management/SalesBookingOrderManagement.vue";
import { deepClone } from "@/utils/deepClone";

/**
 * 报关单据表格
 */
@Component({
  name: "AuditTable",
})
export default class extends Vue {
  @Prop({ required: true }) private data: any;
  @Prop({ required: true })
  private financialConfiguration: FinancialConfiguration;
  @Prop({ required: false }) private item: FactoryInfos;
  @Prop({ required: false, default: false }) private useInvoiceMoney: boolean;
  @Prop({ required: false, default: false }) private canEditAudit: boolean;
  @Prop({ required: true }) private currencyUnit: string;
  private data_: PurchaseOrderProductInfosMore[] = [];
  private maxIndex: number;

  @Watch("data", { immediate: true, deep: true })
  private async watchData() {
    this.data_ = deepClone(this.data);
    await this.getMaxIndex();
  }

  // @Watch("data_", { immediate: true, deep: true })
  // private async watchData_() {
  //   console.log('this.data_2',this.data_)
  // }

  private async getMaxIndex() {
    const newArr = this.data.filter(e => Number(e.deductionAndFilling) > 0)
    if(newArr.length > 0) {
      this.maxIndex = this.data.findIndex((item) => {
        return item.declarationProductAuditChargeId === newArr[0].declarationProductAuditChargeId;
      });
    } else {
      const arr = this.data.filter((item) => {
        return item.productType === 'NORMAL';
      }).map((item) => {
        return item.totalDeclarationAmount;
      });
      this.maxIndex = this.data.findIndex((item) => {
        return item.totalDeclarationAmount === Math.max(...arr);
      });
    }
  }

  private async changeDeductionAndFilling(value) {
    this.$set(this.data_[this.maxIndex], "deductionAndFilling", value);
    this.$nextTick(() => {
      this.$emit('updateDeductionAndFilling', this.data_);
    })
  }

  // 付款单金额=产品货款-补扣款+采购订单费用
  private getPaymentAmount(rows: PurchaseOrderProductInfos) {
    return rows.returnSettlementAmount - rows.deductionAndFilling + rows.purchaseOrderFee;
  }

  // 结算品名总金额=产品货款-其他费用-补扣款+采购订单费用
  private getTotalSettlementAmount(rows: PurchaseOrderProductInfos) {
    if (this.canEditAudit) {
      rows.totalSettlementAmount =
        rows.returnSettlementAmount -
        rows.otherCharge -
        rows.deductionAndFilling +
        rows.purchaseOrderFee;
      this.$emit("calculateFcr", this.data_);
      this.$emit("calculateTotal", "totalSettlementAmount");
    }
    return rows.totalSettlementAmount;
  }

  private getFcr(rows: PurchaseOrderProductInfos) {
    return Number(rows.totalSettlementAmount/1.13/rows.totalDeclarationAmount).toFixed(4);
  }

  // 结算单价=结算品名总金额/数量
  private getSettlementUnitPrice(rows: PurchaseOrderProductInfos) {
    if (this.canEditAudit) {
      rows.settlementUnitPrice = divide(
        rows.totalSettlementAmount,
        rows.productNumberPcs,
        4
      );
    }
    return rows.settlementUnitPrice;
  }

  // 报关品名总金额（美金）=结算品名总金额*1.05/MER
  private getTotalDeclarationAmount(rows: PurchaseOrderProductInfos) {
    if (this.canEditAudit) {
      let mer: number;
      if (this.currencyUnit === "USD") {
        mer = Number(this.financialConfiguration.merUSD);
      } else if (this.currencyUnit === "EURO") {
        mer = Number(this.financialConfiguration.merEURO);
      } else {
        mer = 1;
      }
      rows.totalDeclarationAmount = Number(
        ((rows.totalSettlementAmount * 1.05) / mer).toFixed(4)
      );
    }
    this.$emit("calculateTotal", "totalDeclarationAmount");
    return rows.totalDeclarationAmount;
  }

  private showExtraDialog() {
    this.$emit("showExtraDialog", {
      factoryName: this.item.factoryName,
    });
  }
  private updatePaymentOrder() {
    this.$emit("updatePaymentOrder", {
      factoryName: this.item.factoryName,
    });
  }
  private extraInfoClear() {
    this.data_.forEach((value) => {
      value.deductionAndFilling = null;
      value.deductionAndFillingRemark = null;
    });
  }

  private getPurchaseOrderNumberAndBatch(row: PurchaseOrderProductInfosMore) {
    return row.batch === null
      ? row.purchaseOrderNumber
      : row.purchaseOrderNumber + "(" + row.batch + ")";
  }

  private getExtraInfo(item) {
    this.data_[this.maxIndex].deductionAndFilling = item.deductionAndFilling;
    this.data_[this.maxIndex].deductionAndFillingRemark =
      item.deductionAndFillingRemark;
  }

  private getMaxDescription() {
    return this.data_[this.maxIndex].invoiceDescription;
  }

  private canEditNumber(row: PurchaseOrderProductInfos) {
    return row.settlementUnit && row.settlementUnit.indexOf("千克") > -1;
  }

  private AuditChange(e, row) {
    // this.$emit("AuditChange", e);
    // let sonIndex = this.data.findIndex((res) => res.sn === row.sn);
    // this.$emit("AuditChange", { e, sonIndex });
    this.updateData_();
  }

  private updateData_() {
    // this.$emit("updateData_", this.data_);
    this.$nextTick(() => {
      this.$emit('updateDeductionAndFilling', this.data_);
    })
  }

  private listQuery = {};
  private total = 0;

  private setEnglishUnit(row: PurchaseOrderProductInfosMore) {
    row.settlementUnit = row.unit.invoiceUnit;
    row.englishUnit = row.unit.englishUnit;
    this.updateData_();
  }

  private specialProduct({row,rowIndex}) {
    if (row.special) {
      return 'error-row'
    }
    return ''
  }
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;

  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}
